// @ts-check

/**
 * @file Provides the reusable loading-state text.
 */
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import {Text} from "react-native"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @type {Record<string, object>} */
const styles = {}

/**
 * @typedef {object} LoadingStateProps
 * @property {string} [label] Optional loading label.
 * @property {string} testID Stable test id.
 */

/** @typedef {Record<string, never>} LoadingStateState */

/**
 * Reusable loading indicator text for screens.
 * @augments {ShapeComponent<LoadingStateProps, LoadingStateState>}
 */
class LoadingState extends ShapeComponent {
  static propTypes = propTypesExact({
    label: PropTypes.string,
    testID: PropTypes.string.isRequired
  })
  static defaultProps = {
    label: undefined
  }

  /** Initializes locale hooks for translated loading text. */
  setup() {
    useLocale()
  }

  /**
   * Renders loading text.
   * @returns {ReactNode} Loading-state content.
   */
  render() {
    const {label, testID} = this.p
    return (
      <Text
        style={styles.loadingText ||= {
          color: "#475569",
          fontSize: 15,
          fontWeight: 600
        }}
        testID={testID}
      >
        {label || _("Loading...")}
      </Text>
    )
  }
}

/** @type {NamedExoticComponent<LoadingStateProps>} */
const LoadingStateComponent = memo(shapeComponent(LoadingState))

export default LoadingStateComponent
